import { css } from "@emotion/core";
import { mq } from "../../../cssInJs";

export default {
  pageTiles: css(
    mq({
      display: "flex",
      justifyContent: "flex-start",
      flexWrap: "wrap",
      margin: "2rem -10px",
      overflow: "hidden",
      // marginLeft: ["-10px", null, null, null, "-2rem", "-5.5rem"],
      // marginRight: ["-10px", null, null, null, "-2rem", "-5.5rem"],
    })
  ),
  pageTile__tile: css(
    mq({
      flex: ["0 0 1000%", null, "0 0 100%"],
      maxWidth: ["100%", null, "100%"],
      padding: "10px",
      paddingTop: "3rem",
      zIndex: 1,

      "&:nth-of-type(even)": {
        marginLeft: "auto",
        ".pageTile__bsyc__bg": mq({
          order: ["0", null, "2"],
        }),
        ".pageTile__bsyc__content__details": mq({
          order: "1",
        }),
      },
      "&:nth-of-type(1)": {
        paddingTop: "10px",
      },
    })
  ),

  tile__content: css({
    "&:hover": {
      textDecoration: "none",
      "& .pageTile__bsyc__bg2": {
        transform: "scale(1.02)",
      },
      "& .pageTile__bsyc__content__details": {
        backgroundColor: "#c1272d",
      },
      "& .pageTile__bsyc__title, & .pageTile__bsyc__subtitle, & .pageTile__bsyc__desc, & .pageTile__bsyc__button": {
        color: "#fff !important",
      },
    },
  }),

  tile__flip__wrapper: css(
    mq({
      zIndex: "-1",
      display: "flex",
      flexDirection: "row",
      justifyContent: ["center", null, "space-between"],
      width: "100%",
      height: "100%",
      cursor: "pointer",
      position: "relative",
      flexWrap: "wrap",
      alignItems: "center",
    })
  ),

  tile__bg: css(
    mq({
      height: ["230px", null, "380px", "440px"],
      flex: "1 1 300px",
      overflow: "hidden",
      position: "relative",
      boxShadow: "3px 5px 10px rgba(0,0,0,0.3)",
      '@media (min-width: 1280px)': {
        height: '440px',
      },
      '@media (min-width: 1440px)': {
        height: '480px',
      },
      '@media (min-width: 1600px)': {
        height: '540px',
      },
      '@media (min-width: 1920px)': {
        height: '668px',
      },
      '@media (min-width: 2500px)': {
        height: '668px',
      },
    })
  ),

  tile__bg2: css(
    mq({
      height: "100%",
      overflow: "hidden",
      position: "absolute",
      top: "0px",
      width: "100%",
      transition: "all .3s ease-in-out",
      ".slick-next, .slick-prev": {
        display: "none !important",
      },
    })
  ),

  tile__bg2__inner: css(
    mq({
      backgroundPosition: "50%",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      width: "100%",
      height: ["232px", null, "380px", "440px"],
      '@media (min-width: 1280px)': {
        height: '440px',
      },
      '@media (min-width: 1440px)': {
        height: '480px',
      },
      '@media (min-width: 1600px)': {
        height: '540px',
      },
      '@media (min-width: 1920px)': {
        height: '668px',
      },
      '@media (min-width: 2500px)': {
        height: '668px',
      },
    })
  ),

  tile__details: css(
    mq({
      overflow: "hidden",
      flexGrow: "1",
      textAlign: "left",
      width: "100%",
      bottom: "0",
      backgroundColor: "#FFF",
      color: "#2e3192",
      zIndex: 1,
      flex: ["1 1 300px", null, "1 1 400px"],
      maxWidth: ["300px", null, "calc(870% / 21)"],

      height: ["unset", null, "80%"],
      transition: "all .2s ease-in-out",
      position: "relative",
      marginTop: ["-20px", null, "0px"],
      boxShadow: "3px 5px 10px rgba(0,0,0,0.3)",
      "&.even": mq({
        marginLeft: ["0px", null, "-50px"],
        marginRight: "unset",
      }),
      "&.odd": mq({
        marginRight: ["0px", null, "-50px"],
        marginLeft: "unset",
      }),
      
      "& .pageTile__bsyc__container": mq({
        position: ["static,", null, "absolute"],
        top: "50%",
        left: "50%",
        transform: ["none", null, "translate(-50%, -50%)"],
        width: ["100%", null, "80%"],
        padding: ["1rem", null, "0px"],
        "& .pageTile__bsyc__title": {
          fontFamily: '"proxima-nova",sans-serif',
          fontSize: ["1.5rem", null, "1.9rem", "2.5rem"],
          textTransform: "capitalize",
          fontWeight: "400",
          lineHeight: "1",
          margin: ["0 0 .5rem", null, "0 0 1rem"],
          paddingBottom: [0, null, ".5rem"],
          transition: "color .2s ease-in-out",
          // color: variables.redColor,
        },
        "& .pageTile__bsyc__subtitle": {
          fontSize: ["0.9rem", null, "1rem", "1.2rem", "1.2rem"],
          //textTransform: "capitalize",
          fontWeight: "400",
          lineHeight: ["0.9rem", null, "1rem", "1.2rem", "1.3rem"],
          margin: ["0 0 .5rem", null, "0 0 .8rem"],
          paddingBottom: [0, null, "1rem"],
          transition: "color .2s ease-in-out",
          // color: variables.redColor,
          '@media (min-width: 1601px)': {
            fontSize: "1.4rem",
            lineHeight: "1.4rem",
          },
        },
        "& .pageTile__bsyc__dot": {
          width: "67%",
          marginTop: "0px",
          marginBottom: "0px",
          paddingBottom: "0.5rem",
          borderTopColor: "white",
        },
        "& .pageTile__bsyc__desc": {
          lineHeight: ["0.7rem", null, "0.7rem", "0.8rem", "0.9rem"],
          fontSize: ["0.8rem", null, "0.8rem", "0.8rem", "0.9rem"],
          // minHeight: "70px",
          marginBottom: ["0.5rem", null, "1rem"],
          transition: "color .2s ease-in-out",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          // color: variables.darkGrayColor,
          '@media (min-width: 1601px)': {
            fontSize: "1.1rem",
            lineHeight: "1.1rem",
          },
        },
        "& .pageTile__bsyc__button": {
          fontSize: ["0.7rem", null, "0.7rem", "0.8rem", "0.8rem"],
          lineHeight: ["0.7rem", null, "0.7rem", "0.8rem", "0.8rem"],
          fontWeight: "700",
          color: "#2e3192",
          transition: "color .2s ease-in-out",
          '@media (min-width: 1601px)': {
            fontSize: "1.2rem",
            lineHeight: "1.2rem",
          },
        }
      }),
    })
  ),
};
